import client from './client';

// 탈모진행률 최신 결과 불러오기
export const getHairlossProgressRecent = ({ user_id }) =>
  client.get('/my/user/' + user_id + '/hairloss-progress/diagnosis/recent')